import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import { createContext, useContext, useEffect } from 'react';

var noop = function noop() {};

var leftSidebarState = {
  isFlyoutOpen: false,
  isResizing: false,
  isLeftSidebarCollapsed: false,
  leftSidebarWidth: 0,
  lastLeftSidebarWidth: 0,
  flyoutLockCount: 0
};
export var SidebarResizeContext = /*#__PURE__*/createContext({
  isLeftSidebarCollapsed: false,
  expandLeftSidebar: noop,
  collapseLeftSidebar: noop,
  leftSidebarState: leftSidebarState,
  setLeftSidebarState: noop
});
export var usePageLayoutResize = function usePageLayoutResize() {
  var _useContext = useContext(SidebarResizeContext),
      setLeftSidebarState = _useContext.setLeftSidebarState,
      context = _objectWithoutProperties(_useContext, ["setLeftSidebarState"]);

  return context;
};
/**
 * **WARNING:** This hook is intended as a temporary solution and
 * is likely to be removed in a future version of page-layout.
 *
 * ---
 *
 * This hook will prevent the left sidebar from automatically collapsing
 * when it is in a flyout state.
 *
 * The intended use case for this hook is to allow popup menus in the
 * left sidebar to be usable while it is in a flyout state.
 *
 * ## Usage
 * The intended usage is to use this hook within the popup component
 * you are rendering. This way the left sidebar will be locked for
 * as long as the popup is open.
 */

export var useLeftSidebarFlyoutLock = function useLeftSidebarFlyoutLock() {
  var _useContext2 = useContext(SidebarResizeContext),
      setLeftSidebarState = _useContext2.setLeftSidebarState;

  useEffect(function () {
    setLeftSidebarState(function (current) {
      return _objectSpread(_objectSpread({}, current), {}, {
        flyoutLockCount: current.flyoutLockCount + 1
      });
    });
    return function () {
      setLeftSidebarState(function (current) {
        return _objectSpread(_objectSpread({}, current), {}, {
          flyoutLockCount: current.flyoutLockCount - 1
        });
      });
    };
  }, [setLeftSidebarState]);
};